import React from "react";
import numeral from "numeral";
import { Circle, Popup } from "react-leaflet";
const casesTypeColors = {
  cases: {
    hex: "#CC1034",
    rgb: "rgb(204, 16, 52)",
    half_op: "rgba(204, 16, 52, 0.5)",
    multiplier: 400,
  },
  recovered: {
    hex: "#7dd71d",
    rgb: "rgb(125, 215, 29)",
    half_op: "rgba(125, 215, 29, 0.5)",
    multiplier: 400,
  },
  deaths: {
    hex: "#4D4C4C",
    rgb: "rgb(77 76 76)",
    half_op: "rgba(251, 68, 67, 0.5)",
    multiplier: 2000,
  },
  active: {
    hex: "#faef19",
    rgb: "rgb(250 239 25)",
    half_op: "rgba(251, 68, 67, 0.5)",
    multiplier: 500,
  },
  critical: {
    hex: "#ff6600",
    rgb: "rgb(255 102 0)",
    half_op: "rgba(251, 68, 67, 0.5)",
    multiplier: 2000,
  },
  tests: {
    hex: "#0094b5",
    rgb: "rgb(13 140 168)",
    half_op: "rgba(251, 68, 67, 0.5)",
    multiplier: 50,
  },
};

export const sortData = (data) => {
  let sortedData = [...data];
  sortedData.sort((a, b) => {
    if (a.cases > b.cases) {
      return -1;
    } else {
      return 1;
    }
  });
  return sortedData;
};

export const prettyPrintStat = (stat) =>
  stat ? `+${numeral(stat).format("0.0a")}` : "+0";
  
//Draw Circeson the Map with interactive tooltop
export const showDataOnMap = (data, casesType = "cases") =>
data.map((country) => (
  // let colorMap = casesType == "cases" ? "red" : casesType = "recovered" ? "green" : "black";
  <Circle
    center={[country.countryInfo.lat, country.countryInfo.long]}
    color={casesTypeColors[casesType].hex}
    fillColor={casesTypeColors[casesType].hex}
    fillOpacity={0.4}
    radius={
      Math.sqrt(country[casesType]) * casesTypeColors[casesType].multiplier
    }
  >
    <Popup>
      <div className="info-container">
        <div
          className="info-flag"
          style={{ backgroundImage: `url(${country.countryInfo.flag})` }}
        ></div>
        <div className="info-name">{country.country}</div>
        <div className="info-confirmed">
          Cases: {numeral(country.cases).format("0,0")}
        </div>
        <div className="info-confirmed">
          Active: {numeral(country.active).format("0,0")}
        </div>
        <div className="info-confirmed">
          Critical: {numeral(country.critical).format("0,0")}
        </div>
        <div className="info-confirmed">
          Recovered: {numeral(country.recovered).format("0,0")}
        </div>
        <div className="info-confirmed">
          Deaths: {numeral(country.deaths).format("0,0")}
        </div>
        <div className="info-confirmed">
          Tests: {numeral(country.tests).format("0,0")}
        </div>
      </div>
    </Popup>
  </Circle>
)
);



//Draw Circeson the Map with interactive tooltop recovered
export const showDataOnMapRecovred = (data, casesType = "cases") =>
  data.map((country) => (
    // let colorMap = casesType == "cases" ? "red" : casesType = "recovered" ? "green" : "black";
    <Circle
      center={[country.countryInfo.lat, country.countryInfo.long]}
      color={casesTypeColors[casesType].hex}
      fillColor={casesTypeColors[casesType].hex}
      fillOpacity={0.4}
      radius={
        Math.sqrt(country[casesType]) * casesTypeColors[casesType].multiplier
      }
    >
      <Popup>
      <div className="info-container">
        <div
          className="info-flag"
          style={{ backgroundImage: `url(${country.countryInfo.flag})` }}
        ></div>
        <div className="info-name">{country.country}</div>
        <div className="info-confirmed">
          Cases: {numeral(country.cases).format("0,0")}
        </div>
        <div className="info-confirmed">
          Active: {numeral(country.active).format("0,0")}
        </div>
        <div className="info-confirmed">
          Critical: {numeral(country.critical).format("0,0")}
        </div>
        <div className="info-confirmed">
          Recovered: {numeral(country.recovered).format("0,0")}
        </div>
        <div className="info-confirmed">
          Deaths: {numeral(country.deaths).format("0,0")}
        </div>
        <div className="info-confirmed">
          Tests: {numeral(country.tests).format("0,0")}
        </div>
      </div>
      </Popup>
    </Circle>
  )
  );